import type { WalletTopUpSuggestion } from '../../types/strategy'

function fmtSol(n: number) {
  return n.toLocaleString('en-US', { maximumFractionDigits: 3, minimumFractionDigits: 2 })
}
function fmtUsd(n: number) {
  return '$' + Math.abs(n).toLocaleString('en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 })
}

interface Props {
  suggestion: WalletTopUpSuggestion
}

/**
 * Rendered above the stage strip when the wallet's SOL-equivalent is below the
 * borrow-derived reserve requirement. Never suggests unstaking LSTs.
 */
export default function WalletTopUpCard({ suggestion }: Props) {
  return (
    <div className="bg-amber-500/5 border border-amber-500/30 rounded-xl px-3 py-2 flex items-center gap-3">
      <div className="w-8 h-8 rounded-lg bg-amber-500/15 flex items-center justify-center text-amber-400 shrink-0">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="w-4 h-4">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[11px] font-semibold text-amber-300 uppercase tracking-wide">
          Top up wallet for safe reserve
        </div>
        <div className="text-[13px] text-ink mt-0.5">
          Add ~<span className="font-semibold">{fmtSol(suggestion.shortfallSol)} SOL</span>{' '}
          (~<span className="font-semibold">{fmtUsd(suggestion.shortfallUsd)}</span>) — do NOT unstake LSTs
        </div>
        <div className="text-[10px] text-ink-muted mt-0.5">
          Have {fmtSol(suggestion.currentWalletSol)} SOL / need {fmtSol(suggestion.requiredSol)} SOL
        </div>
      </div>
    </div>
  )
}
